import React from 'react';
import { Card, Button, CardBody, Progress,  FormText
} from 'reactstrap';
import {appHelpers, store} from '../../_helpers';


import NotificationSystem from 'react-notification-system';
 import {connect} from "react-redux";
import {alertActions, commonActions, modalActions} from "../../_actions";
import {alertConstants, appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";
// import {apiService} from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
 // import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
import IataValidationPageRecords from "./iata-validation-page-records";
//Icons
import ToolTipItem from "../utils/tooltip";

import {commonService} from "../../_services";


const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class IataViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airlines: [],
            isInitiator: false,
            IataValidation: null,
            validationRecords: [],
            Workflow: [],
            UserActionType: null,
            WorkflowLastAction: null,
            WorkflowFirstAction: null,
            TotalPassengers: 0,
            FlightNumber: 0,
            FlightDate: null,
            airports: [],
            categories: [
                {
                    Id: 1,
                    Name : 'Domestic'
                },
                {
                    Id : 2,
                    Name: 'International'
                }
            ],
            modal: false,
            modalClass: '',
            //Airport form
            AirlineCode: '',
            AirlineId: '',
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            validatingStatus: 0,
            UserId: '',
            IataValidationId: '',
            IataValidationProcessName: appConstants.IATA_PROCESS_NAME
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let { authentication } = reduxState;
        if(authentication){
            if(authentication.user !== undefined){
                this.setState({
                    UserId: authentication.user.userId
                });
                this.getUserWorkflowAction(authentication.user.userId);
                this.setupComponents();
            }
        }
        const  queryString = window.location.href.split('/');
        const  IataValidationId = queryString[queryString.length - 1];
        this.setState({IataValidationId});

        // this.fetchValidationRecords(IataValidationId);
        // this.fetchIataValidation(IataValidationId);
        // this.getWorkflow();
    }

    componentWillReceiveProps = function (nextProps) {
        const {alert} = nextProps;
        const {modal} = nextProps;
        const  queryString = window.location.href.split('/');
        this.setState({IataValidationId: queryString[queryString.length - 1]});

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({error: false, success: 'Operation successful'});
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({success: false, error: false})

            } else {
                this.setState({success: false, error: alert.message})
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                });
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }

    };

    setupComponents = () => {

        let { dispatch } = this.props;
        let { TotalCount, IataValidationProcessName } = this.state;

        dispatch(apiActions.startFullPageRequest());
        // this.getUserWorkflowAction(authentication.user.userId)
        const  queryString = window.location.href.split('/');
        const  IataValidationId = queryString[queryString.length - 1];
        const validationRecordParams = {
            "From": 0,
            "PageSize": TotalCount,
            "Parameter":{
                IataValidationId
            }
        };
        const validationDetailsParams = {
            "From": 0,
            "PageSize": 1,
            "Parameter":{
                IataValidationId
            }
        };

        const workflowParam  = {
            "From": 0,
            "PageSize": 1,
            Parameter: {
                WorkflowProcessName: IataValidationProcessName,
                IncludeWorkflowActions: true
            }
        };
        Promise.all([commonService.searchIATAValidationDetails(validationRecordParams), commonService.getIATAValidation(validationDetailsParams), commonService.getWorkFlows(workflowParam)])
            .then(response => {
                let error_message = false;
                let IataValidation = null;
                let WorkflowFirstAction = null;
                /*Process Validation Record Details API */
                const validationRecordDetails = response[0];
                if (validationRecordDetails.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = validationRecordDetails.response.Results;
                    let FlightDate = false;
                    let FlightNumber = '';
                    if(validationRecords.length){
                        FlightNumber = validationRecords[0]['FlightNumber'];
                        FlightDate = validationRecords[0]['FlightDate']
                    }
                    this.setState({ validationRecords, FlightNumber, FlightDate, TotalPassengers: validationRecordDetails.response.TotalCount});
                }
                else if (validationRecordDetails.status === appConstants.ERROR_RESPONSE) {
                    error_message = 'Currently unable to get records.';
                }

                /*Process Validation Record API */
                const validationDetails = response[1];
                if (validationDetails.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = validationDetails.response.TotalCount; //res.response.Results;
                    if(validationRecords > 0){
                        IataValidation = validationDetails.response.Results[0];
                        this.setState({IataValidation});
                    }else{
                        error_message = 'IATA Validation does not exist';
                    }
                } else if (validationDetails.status === appConstants.ERROR_RESPONSE) {
                    error_message = 'Currently unable to get records.';
                }

                /*Workflow  Record API */
                const workflowDetails = response[2];
                if (workflowDetails.status === appConstants.SUCCESS_RESPONSE) {
                    if(workflowDetails.response.TotalCount > 0) {
                        this.setState({Workflow: workflowDetails.response.Results[0]});
                        this.setWorkflowLastAction(workflowDetails.response.Results[0].WorkflowActions);
                        WorkflowFirstAction = this.getWorkflowFirstAction(workflowDetails.response.Results[0].WorkflowActions)
                    }else{
                        error_message = 'Workflow does not exist';
                    }
                } else if (workflowDetails.status === appConstants.ERROR_RESPONSE) {
                    error_message = workflowDetails.response;
                }

                let { isInitiator, contentError } = this.checkInitiatorState(WorkflowFirstAction, IataValidation);

                this.setState({ contentError: (contentError ? contentError : error_message), isInitiator });
                dispatch(apiActions.endRequest());
            }).catch(err => {
            this.setState({ contentError: 'Sorry, currently unable to display page'});
            dispatch(apiActions.endRequest());
        });
    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        this.setState(currState);
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.Name === ''){
            _errs_['Name'] = 'Please enter  airport name';
            formValid = false;
        }

        if(this.state.Code === ''){
            _errs_['Code'] = 'Please enter airport code';
            formValid = false;
        }

        if(this.state.CountryCode === '') {
            _errs_['CountryCode'] = 'Please select country';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({componentError: false, componentErrorMessages: [], airportId: false, Name: '', Code: '', CountryCode: '', IsLocal: false });
        this.resetError();
    }

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    processSubmit = () => {
        let {airportId} = this.state;
        let payload = {
            Name: this.state.Name, Code: this.state.Code,
            CountryCode: this.state.CountryCode,
            IsLocal: this.state.IsLocal
        };
        if (airportId) {
            payload.Id = airportId;
        }
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        dispatch(commonActions.manageAirport(payload))
            .then(res => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle(null, 'modalSlide');
                    let msg = (payload.Id) ? 'Airport edited successfully' : 'Airport created successfully';
                    this.notify(msg, appConstants.NOTIFY_SUCCESS);
                    this.fetchAirports();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });
    };

    setWorkflowLastAction = (workflowActions) => {
        let WorkflowLastAction = workflowActions[0];
        for(let item of workflowActions){
            if(item.ActionLevel > WorkflowLastAction.ActionLevel){
                WorkflowLastAction = item
            }
        }
        this.setState({WorkflowLastAction});
    };

    setWorkflowFirstAction = (workflowActions) => {
        let WorkflowFirstAction = workflowActions[0];
        for(let item of workflowActions){
            if(item.ActionLevel < WorkflowFirstAction.ActionLevel){
                WorkflowFirstAction = item
            }
        }
        this.setState({WorkflowFirstAction});
    };
    getWorkflowFirstAction = (workflowActions) => {
        let WorkflowFirstAction = workflowActions[0];
        for(let item of workflowActions){
            if(item.ActionLevel < WorkflowFirstAction.ActionLevel){
                WorkflowFirstAction = item
            }
        }
        return WorkflowFirstAction;
    };
/*
    fetchIataValidation = (IataValidationId) => {
        let payload = {
            "From": 0,
            "PageSize": 1,
            "Parameter":{
                IataValidationId
            }
        };
        commonService.getIATAValidation(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = res.response.TotalCount; //res.response.Results;
                    if(validationRecords > 0){
                        this.setState({IataValidation: res.response.Results[0]});
                        // dispatch(apiActions.endRequest());
                    }else{
                        this.notify('IATA does not exist', appConstants.NOTIFY_ERROR);
                        // dispatch(apiActions.endRequest());
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get records.', appConstants.NOTIFY_ERROR);
                    // dispatch(apiActions.endRequest());
                }
            });
    };
    fetchValidationRecords = (IataValidationId) => {
        let {dispatch } = this.props;
        dispatch(apiActions.startFullPageRequest());

        let { TotalCount } = this.state;

        let payload = {
            "From": 0,
            "PageSize": TotalCount,
            "Parameter":{
                IataValidationId
            }
        };
        commonService.searchIATAValidationDetails(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = res.response.Results;
                    let FlightDate = false;
                    let FlightNumber = '';
                    if(validationRecords.length){
                        FlightNumber = validationRecords[0]['FlightNumber'];
                        FlightDate = validationRecords[0]['FlightDate']
                    }
                    this.setState({ validationRecords, FlightNumber, FlightDate, TotalPassengers: res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get records.', appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };*/

    fetchAirlines = () => {
        this.setState({contentError: false});
        const {dispatch} = this.props;

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                let {airlinesCarriers} = this.props;
                this.setState({airlines: airlinesCarriers.Results });
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };


    fetchAirports = () => {
         this.setState({contentError: false});
        const {dispatch, desAirports} = this.props;

        if(!desAirports){
            dispatch(apiActions.startFullPageRequest());
        }else{
            dispatch(apiActions.startRequest());
        }

        dispatch(commonActions.getDesAirports())
            .then(() => {
                let {desAirports} = this.props;
                let { defaultAllAirport } = this.state;
                this.setState({airports: [defaultAllAirport, ...desAirports.Results]});
                dispatch(apiActions.endRequest());
            }).catch(error => {
                 let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({contentError: errorMessage});
                dispatch(apiActions.endRequest());
        });
    };
    toggle = (e, modalClass) => {
        if(this.state.modal){
            this.resetForm();
            this.props.dispatch(modalActions.close({'modalClass': modalClass}));
        }else{
            this.props.dispatch(modalActions.open({'modalClass': modalClass}));
        }
    };

    saveValidationRecord = (payload, IATAId) => {
        let  { dispatch } = this.props;
        let  { UserId } = this.state;
        let validatingStatus = 1 ;
        this.setState({ validatingStatus});

        let params = {
            IataValidationId: IATAId,
            UserId: UserId,
            Entries: [payload]
        };

        commonService.updateIATAValidationDetail(params)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    validatingStatus = 0;
                    this.setState({ validatingStatus });
                    this.notify('Changes saved successfully', appConstants.NOTIFY_SUCCESS);
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };

    transitionValidationRecord = () => {
        let  { dispatch } = this.props;
        let  { UserId, IataValidationId } = this.state;

        let params = {
            IataValidationId,
            UserId: UserId,
        };
        dispatch(apiActions.startRequest());

        commonService.transitionIataWorkflowState(params)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.notify('Changes saved successfully', appConstants.NOTIFY_SUCCESS);
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };
    declineValidationRecord = () => {
        let  { dispatch } = this.props;
        let  { UserId, IataValidationId } = this.state;

        let params = {
            IataValidationId,
            UserId: UserId,
        };
        dispatch(apiActions.startRequest());

        commonService.reInitializeWorkflowState(params)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.notify('Changes declined successfully', appConstants.NOTIFY_SUCCESS);
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };
    getUserWorkflowAction = (UserId) => {
        let  { dispatch } = this.props;
        let  { IataValidationProcessName} = this.state;

        let payload = {
            "From": 0,
            "PageSize": 1,
        };
        let params = {
            WorkflowProcessName: IataValidationProcessName,
            UserId,
        };
        payload.Parameter = params;
        dispatch(apiActions.startRequest());

        commonService.getWorkFlowUsers(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if(res.response.TotalCount > 0) {
                        this.setState({ UserActionType: res.response.Results[0]});
                    }else{
                        this.setState({contentError: 'You don\'t have privilege to continue'});
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                }
            });
    };

    getWorkflow = () => {
        let  { IataValidationProcessName} = this.state;
        let payload = {
            "From": 0,
            "PageSize": 1,
        };
        let params = {
            WorkflowProcessName: IataValidationProcessName,
            IncludeWorkflowActions: true
        };
        payload.Parameter = params;

        commonService.getWorkFlows(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if(res.response.TotalCount > 0) {
                        this.setState({Workflow: res.response.Results[0]});
                        this.setWorkflowLastAction(res.response.Results[0].WorkflowActions);
                        this.setWorkflowFirstAction(res.response.Results[0].WorkflowActions);
                    }else{
                        this.setState({contentError: 'Workflow does not exist'});
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                   // dispatch(apiActions.endRequest());
                }
            });
    };

    checkInitiatorState = (WorkflowFirstAction, IataValidation) => {
        let {  UserActionType } = this.state;
        let isInitiator;
        let contentError = false;
        if(WorkflowFirstAction && UserActionType && IataValidation) {
            if ((WorkflowFirstAction !== null && UserActionType !== null) && (UserActionType.ActionLevel === WorkflowFirstAction.ActionLevel)){
                // isInitiator = UserActionType.UserId === IataValidation.CreatedBy
                if(UserActionType.UserId === IataValidation.CreatedBy){
                    isInitiator = true;
                }else{
                    contentError = 'Sorry, You don\'t have privilege to continue';
                }
            }else{
                isInitiator = false;
            }
        } else{
            isInitiator = false;
        }
        return {isInitiator: isInitiator, contentError: contentError}
    };

    notifyCallBack = (message, level) => {
        this.notify(message, level)
    };

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        const { requesting, pageRequesting } = this.props;
        const {  isInitiator, UserActionType, WorkflowLastAction, contentError, validationRecords, FlightNumber, FlightDate, TotalPassengers, UserId, IataValidationId, IataValidation } = this.state;
        let validationRecordsLength = validationRecords.length;
        // let isInitiator = this.checkInitiatorState();
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress animated striped color="success" value={100} className="mb-2"/> }

                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                             <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                             <CardBody className="table-responsive">
                            <div className="row">
                                <h6 className="mb-4 col-md-4 text-uppercase pull-left">IATA Validation
                                    <FormText color="muted">
                                        Last worked on &nbsp;
                                        {
                                            (IataValidation && IataValidation.UpdatedOn) &&
                                            appHelpers.formatDateSpecific(IataValidation.UpdatedOn)
                                        }
                                        {
                                            (IataValidation && !IataValidation.UpdatedOn) &&
                                            appHelpers.formatDateSpecific(IataValidation.CreatedOn)
                                        }
                                    </FormText>
                                </h6>
                                <div className="mb-4 col-md-8 text-right pull-right">
                                    {
                                        (IataValidation && IataValidation.ValidationStatus === 1) &&
                                         <ToolTipItem key={'completedBtn'} title={<Button className="btn-avi-secondary" disabled={ requesting }> Completed </Button>} content='All changes approved' id={'completedBtn'}/>
                                    }

                                    {
                                        ((IataValidation && IataValidation.ValidationStatus === 0) && (WorkflowLastAction !== null && UserActionType !== null) && (UserActionType.ActionLevel === WorkflowLastAction.ActionLevel)) &&
                                        <span>
                                            <ToolTipItem key={'validationApproveBtn'} title={<Button className="btn-avi-secondary" disabled={ requesting } onClick={this.declineValidationRecord}> Decline Changes </Button>} content='Decline all changes' id={'validationReviewBtn'}/>
                                            &nbsp;&nbsp;
                                        </span>

                                    }
                                    {
                                        (IataValidation && IataValidation.ValidationStatus === 0) &&
                                        <ToolTipItem key={'validationApproveBtn'} title={<Button className="btn-avi-primary" disabled={ requesting } onClick={this.transitionValidationRecord}> Submit Changes </Button>} content='Proceed to the next level' id={'validationReviewBtn'}/>
                                    }
                                </div>
                            </div>

                            <div>
                                {/*<IataFilterValidationForm componentErrorMessages={this.state.componentErrorMessages} airports={airports} airlines={airlines} categories={categories} selectedCategory={selectedCategory} searchAirportCode={searchAirportCode} sourceAirportId={sourceAirportId} destinationAirportId={destinationAirportId} onSubmit={this.filterIATA} handleSelectChange={this.handleSelectChange}  handleDateChange={this.handleDateChange} />*/}
                            </div>


                            {(!pageRequesting &&  validationRecordsLength > 0) &&
                              <IataValidationPageRecords isInitiator={isInitiator} notifyCallBack={this.notifyCallBack} IataValidationId={IataValidationId} UserId={UserId} TotalPassengers={TotalPassengers} FlightDate={FlightDate} FlightNumber={FlightNumber} validationRecords={ validationRecords } saveValidationCallback={this.saveValidationRecord}/>
                            }

                            {(!pageRequesting && validationRecordsLength === 0) &&
                                <PageEmptyContent message='No records yet!'/>
                            }
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
    const { modal, alert, airlinesCarriers, desAirports} = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        desAirports,
        airlinesCarriers
    };
}
export default connect(mapStateToProps)(IataViewContent);



// WEBPACK FOOTER //
// ./src/views/iataValidation/view-validation-content.js